import { openTelemetry } from "@/_old/lib/open-telemetry";

openTelemetry.initialize();
